module.exports = __webpack_public_path__ + "img/voiture-base-stock.735ea012.png";